(() => {
  const normalize = (value) => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  function init(root) {
    if (root.dataset.spFaqReady === 'true') return;
    root.dataset.spFaqReady = 'true';

    const input = root.querySelector('[data-sp-faq-search]');
    const clear = root.querySelector('[data-sp-faq-clear]');
    const status = root.querySelector('[data-sp-faq-status]');
    const empty = root.querySelector('[data-sp-faq-empty]');
    const categories = [...root.querySelectorAll('[data-sp-faq-category]')];
    const links = [...root.querySelectorAll('[data-sp-faq-nav]')];
    const items = [...root.querySelectorAll('[data-sp-faq-item]')];
    if (!input || !clear || !status || !empty) return;

    items.forEach((item) => {
      item.dataset.spFaqText = normalize(item.textContent || '');
    });

    let scheduled = false;
    function markCurrent() {
      scheduled = false;
      if (!root.isConnected) return;
      const visible = categories.filter((category) => !category.hidden);
      const current = [...visible].reverse().find((category) => category.getBoundingClientRect().top <= 180) || visible[0];
      links.forEach((link) => {
        if (link.dataset.spFaqNav === current?.dataset.spFaqCategory) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }

    function scheduleCurrent() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(markCurrent);
    }

    function filter() {
      const query = normalize(input.value.trim());
      let total = 0;
      clear.hidden = !query;

      categories.forEach((category) => {
        let visible = 0;
        category.querySelectorAll('[data-sp-faq-item]').forEach((item) => {
          const matches = !query || item.dataset.spFaqText.includes(query);
          item.hidden = !matches;
          if (matches) visible += 1;
        });
        category.hidden = visible === 0;
        total += visible;

        const count = category.querySelector('[data-sp-faq-category-count]');
        if (count) count.textContent = `${visible} question${visible > 1 ? 's' : ''}`;
        const nav = links.find((link) => link.dataset.spFaqNav === category.dataset.spFaqCategory);
        if (nav) {
          nav.hidden = visible === 0;
          const number = nav.querySelector('small');
          if (number) number.textContent = String(visible);
        }
      });

      empty.hidden = total > 0;
      status.textContent = query
        ? `${total} résultat${total > 1 ? 's' : ''} pour « ${input.value.trim()} »`
        : `${items.length} questions · ${categories.length} thèmes`;
      scheduleCurrent();
    }

    input.addEventListener('input', filter);
    clear.addEventListener('click', () => {
      input.value = '';
      filter();
      input.focus();
    });
    window.addEventListener('scroll', scheduleCurrent, { passive: true });
    window.addEventListener('resize', scheduleCurrent, { passive: true });
    links.forEach((link) => link.addEventListener('click', () => {
      links.forEach((other) => other.removeAttribute('aria-current'));
      link.setAttribute('aria-current', 'location');
    }));

    filter();
  }

  document.querySelectorAll('[data-sp-faq]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-sp-faq]').forEach(init);
  });
})();
